/**
 * Tooltip eines Bearbeitungswegs – überall gleich, ob am Status in der Nachweisliste oder an
 * einer Wegauswahl: oben „Bearbeitungsweg: Beauftragen“, darunter die Beschreibung des Servers
 * (`/processing-path-options`, höchstens zwei Zeilen im Tooltip).
 */
import React from "react";
import { InfoTooltipContent } from "../../../common/overlays/InfoTooltip";
import { ProcessingPathOption } from "../../../../types";

export const processingPathHeading = (
  path: Pick<ProcessingPathOption, "label">,
): string => `Bearbeitungsweg: ${path.label}`;

export const processingPathTooltip = (
  path: Pick<ProcessingPathOption, "label" | "description">,
): React.ReactNode => (
  <InfoTooltipContent heading={processingPathHeading(path)}>
    {path.description}
  </InfoTooltipContent>
);
